import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as fromBackPataCopilsActions from '@apps/back/store/pata/copils/copils.actions';
import { CopilsMiscDomainService } from '@apps/pata/domain/copils-misc-domain.service';
import { Copil } from '@apps/pata/domain/models/copil';
import { IAuroraState } from '@apps/aurora.state';
import { Store } from '@ngrx/store';

@Injectable({
    providedIn: 'root'
})
export class BackPataCopilEffects
{
    constructor (
        private store: Store<IAuroraState>,
        private actions: Actions,
        private copilsService: CopilsMiscDomainService
    )
    {}

    backPataCopilsListRequested = createEffect(
        () =>
            this.actions.pipe(
                ofType(fromBackPataCopilsActions.BackPataCopilsListRequested),
                switchMap(() =>
                    this.copilsService.getAllCopils()
                        .pipe(
                            map((copils: Copil[]) =>
                                fromBackPataCopilsActions.BackPataCopilsListSucceeded({ copils })
                            ),
                            catchError(() =>
                                of(fromBackPataCopilsActions.BackPataCopilsListFailed())
                            )
                        )
                )
            )
    );
}
